import TrendingCardLoading from './trendingCard.component';

export default TrendingCardLoading;